module.exports = __webpack_public_path__ + "img/pcs.fd966eb3.jpg";